"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LogoCircleFull = void 0;

var _react = _interopRequireDefault(require("react"));

var _jsxRuntime = require("react/jsx-runtime");

/**
 * The JOBMATCH.ME Circle Logo with Job Match Me text
 *
 * @param {width}         size  Logo width
 * @param {height}        size  Logo height
 * @param {background}    color Background color
 * @param {primary}       color Primary color
 * @param {secondary}     color Secondary color
 * @param {tertiary}      color Tertiary color
 *
 **/
var LogoCircleFull = function LogoCircleFull(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '100' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '100' : _ref$height,
      _ref$background = _ref.background,
      background = _ref$background === void 0 ? '#3ecd84' : _ref$background,
      _ref$primary = _ref.primary,
      primary = _ref$primary === void 0 ? '#004324' : _ref$primary,
      _ref$secondary = _ref.secondary,
      secondary = _ref$secondary === void 0 ? '#ffed00' : _ref$secondary,
      _ref$tertiary = _ref.tertiary,
      tertiary = _ref$tertiary === void 0 ? '#fff' : _ref$tertiary;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "logoJMM",
    width: width,
    height: height,
    viewBox: "0 0 1427 1427",
    style: {
      transform: "rotate(-10deg)"
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      transform: "translate(-1577 -6891.764)",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
        fill: background,
        cx: "713.5",
        cy: "713.5",
        r: "713.5",
        transform: "translate(1577 6891.764)"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        fill: primary,
        d: "M1805.267,6979.348h67.508v158.076s-3.905,79.469-94.026,80.039-99.513-80.039-99.513-97.125h67.516s-4.17,34.973,28.17,34.973,30.344-34.973,30.344-34.973Z",
        transform: "translate(252.805 215.462)"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        fill: primary,
        d: "M130.451,244.552C125.165,244.552.984,243.168.006,122.69c-.283-34.844,10.072-63.1,30.778-83.971a116.707,116.707,0,0,1,31.531-22.3,157.187,157.187,0,0,1,32.217-11.5A167.569,167.569,0,0,1,130.589,0h.021a137.129,137.129,0,0,1,19.576,2.016A159.644,159.644,0,0,1,193.311,15.6c18.232,8.955,32.792,21.221,43.277,36.457,13.106,19.044,19.844,42.809,20.027,70.633.232,35.144-10.145,63.529-30.845,84.366a114.249,114.249,0,0,1-30.506,21.652,150.661,150.661,0,0,1-30.883,11.134,155.133,155.133,0,0,1-33.771,4.71Zm-2.142-61.438h0c.028,0,.7.044,1.859.044,5.283,0,18.938-.845,31.606-8.674a48.354,48.354,0,0,0,17.1-18c5-9.069,7.66-20.333,7.9-33.481.354-19.348-4.827-34.618-15.4-45.386-6.743-6.868-15.506-11.774-26.046-14.583a67.729,67.729,0,0,0-16.6-2.348c-.28,0-.427,0-.427,0a64.512,64.512,0,0,0-28.495,7.854,51.656,51.656,0,0,0-19.4,18.507C74.536,96.722,71.49,108.818,71.36,123c-.173,18.89,4.956,33.731,15.243,44.113,15.1,15.241,36.709,16.013,40.887,16.013C127.994,183.126,128.278,183.116,128.309,183.115Z",
        transform: "translate(2147.084 7187.475)"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        fill: primary,
        d: "M145.187,233.269H0V0H132.585A95.936,95.936,0,0,1,162.5,8.948c8.731,4.375,15.744,9.924,20.844,16.493,6.373,8.211,9.755,18.045,10.051,29.229s-1.451,20.942-5.195,29a42.358,42.358,0,0,1-31.482,24.194h.005l.051,0c.211-.01.854-.041,1.785-.041,4.972,0,17.807.83,29.582,8.517a45.893,45.893,0,0,1,15.765,17.559c4.581,8.824,6.985,19.783,7.148,32.574.181,14.283-3.169,26.682-9.958,36.852a61.788,61.788,0,0,1-22.681,20.028A91.732,91.732,0,0,1,145.187,233.269Zm-79.1-92.117v36.765h56.193a30.839,30.839,0,0,0,9.925-2.942,19.094,19.094,0,0,0,6.823-5.518,17.236,17.236,0,0,0,0-19.728,19.286,19.286,0,0,0-6.823-5.566,31.05,31.05,0,0,0-9.925-3.011Zm0-86.819V91.1h45.772a30.553,30.553,0,0,0,9.926-2.944,19.116,19.116,0,0,0,6.826-5.52,17.236,17.236,0,0,0,0-19.725,19.284,19.284,0,0,0-6.826-5.566,31.057,31.057,0,0,0-9.917-3.012Z",
        transform: "translate(2435.018 7192.839)"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        fill: primary,
        d: "M65.26,231.364H0V0H36.87l89.577,110.453L214.952,0h36.327V231.364H186.342v-95.27L138.2,193.388H114.166L65.26,136.094Z",
        transform: "translate(2083.693 7784.361)"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        fill: primary,
        d: "M0,230.86V0H184.028V56.978H64.458V88.522H164.546v54.206H64.458v32.3h119.57V230.86Z",
        transform: "translate(2371.053 7784.865)"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("ellipse", {
        fill: secondary,
        cx: "37.104",
        cy: "37.104",
        rx: "37.104",
        ry: "37.104",
        transform: "translate(1974.203 7934.942)"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        fill: tertiary,
        d: "M65.26,231.364H0V0H36.87l89.577,110.453L214.952,0h36.327V231.364H186.342v-95.27L138.2,193.388H114.166L65.26,136.094Z",
        transform: "translate(1705.165 7489.177)"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        fill: tertiary,
        d: "M263.425,229.626h-.005l-74.7,0-15.34-34.508H89.266L76.5,229.621H0L110.682,0h47.307L263.423,229.621ZM133.391,81.1l-21.613,61.44h42.734Z",
        transform: "translate(1971.912 7490.918)"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        fill: tertiary,
        d: "M1756.554,7064.613h205.635v58.035h-68.138v173.141h-67.978V7122.648h-69.52Z",
        transform: "translate(443.99 426.306)"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        fill: tertiary,
        d: "M130.451,244.552C125.165,244.552.984,243.167.006,122.69c-.283-34.844,10.072-63.1,30.778-83.971a116.707,116.707,0,0,1,31.531-22.3,157.186,157.186,0,0,1,32.217-11.5A167.568,167.568,0,0,1,130.589,0h.021a155.989,155.989,0,0,1,37.1,5.987A145.016,145.016,0,0,1,201.065,19.9a112.631,112.631,0,0,1,31.647,26.9L179.236,91.917A52.906,52.906,0,0,0,164.9,75.294a69.762,69.762,0,0,0-16.8-9.43,80.413,80.413,0,0,0-19.791-5.177,64.513,64.513,0,0,0-28.495,7.854,51.655,51.655,0,0,0-19.4,18.507C74.536,96.722,71.49,108.818,71.36,123c-.173,18.89,4.956,33.732,15.243,44.114,15.1,15.241,36.709,16.013,40.887,16.013.53,0,.816-.012.819-.012a70.406,70.406,0,0,0,17.995-4.228,66.648,66.648,0,0,0,15.81-8.351,55.013,55.013,0,0,0,14.41-15.235L232.5,199.567a105.106,105.106,0,0,1-30.921,25.979A143.162,143.162,0,0,1,168.319,238.9a159.547,159.547,0,0,1-37.708,5.648Z",
        transform: "translate(2414.485 7482.659)"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        fill: tertiary,
        d: "M146.656,235V154.33H66.344V235H0V0H66.344V94.7h80.313V0H213V235Z",
        transform: "translate(2662 7490.764)"
      })]
    })
  });
};

exports.LogoCircleFull = LogoCircleFull;

var _default = /*#__PURE__*/_react.default.memo(LogoCircleFull);

exports.default = _default;